var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('van-overlay',{attrs:{"show":_vm.$store.state.reqLoading}},[_c('div',{staticClass:"reporting-wrapper"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }